import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { motion, AnimatePresence } from "framer-motion";

import magotSegar from "../../assets/produk/magot-segar.png";
import magotProses from "../../assets/produk/magot-proses.png";
import pupukKasgot from "../../assets/produk/pupuk-kasgot.png";
import mawasWasteBox from "../../assets/produk/mawas.png";

import Tokopedia from "../../assets/produk/tokopedia.png";
import decoreKanan from "../../assets/home/decore-produk.png";

const Produk = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);

  const products = [
    {
      title: "Magot Segar",
      img: magotSegar,
      desc: "Maggot hidup berkualitas tinggi sumber protein. Pilihan ideal pakan hewan ternak!",
    },
    {
      title: "Magot Proses",
      img: magotProses,
      desc: "Kandungan protein yang tinggi dan sudah melalui uji lab milik Universitas Gadjah Mada sangat tepat sebagai nutrisi tambahan hewan ternak",
    },
    {
      title: "Pupuk Kasgot",
      img: pupukKasgot,
      desc: "Telah teruji dan terbukti menghasilkan hasil yang bagus untuk pertanian. Secara efektif memperbaiki struktur tanah dan menyediakan nutrisi serta masih banyak lagi manfaatnya!",
    },
    {
      title: "MaWas Waste Box",
      img: mawasWasteBox,
      desc: "Layanan tempat sampah organik yang mengurai limbah rumah tangga secara efisien. Solusi tepat atasi sampah yang bebas repot!",
    },
  ];

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setSelectedProduct(null);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <div className="bg-light py-5 lg:pt-20" id="produk">
      <div className="px-2 xl:px-12">
        <div className="w-full relative">
          <h1 className="text-center text-3xl xl:text-4xl font-bold noto-sans">
            Produk Kami
          </h1>
          <img
            src={decoreKanan}
            alt=""
            className="absolute -right-5 -z-10 lg:-right-12"
          />
        </div>

        {/* Mobile View */}
        <div className="lg:hidden noto-sans">
          <Slider className="mt-6 text-lg" {...settings}>
            {products.map((product, index) => (
              <div
                key={index}
                className="text-center relative px-20"
                onClick={() => setSelectedProduct(product)}
              >
                <img
                  src={product.img}
                  alt={product.title}
                  className="rounded-3xl drop-shadow-lg w-full lg:max-w-72 mx-auto cursor-pointer"
                />
                <div
                  className="bg-white p-3 mx-auto text-center w-[100%] rounded-b-3xl transition-transform duration-300 lg:group-hover:scale-105"
                  style={{ transform: "translateY(-100%)" }}
                >
                  <p className="font-bold text-center">{product.title}</p>
                </div>
              </div>
            ))}
          </Slider>
        </div>

        {/* Desktop View */}
        <div className="hidden lg:flex flex-row pt-12 lg:text-lg items-center justify-center noto-sans">
          {products.map((product, index) => (
            <div
              key={index}
              className="text-center relative px-6 lg:px-12"
              onClick={() => setSelectedProduct(product)}
            >
              <div className="group cursor-pointer transition-transform duration-300 lg:hover:scale-110">
                <img
                  src={product.img}
                  alt={product.title}
                  className="w-full rounded-3xl drop-shadow-lg lg:max-w-sm mx-auto"
                />
                <div
                  className="bg-white p-6 mx-auto text-center w-[100%] rounded-b-3xl "
                  style={{ transform: "translateY(-100%)" }}
                >
                  <p className="font-bold text-center">{product.title}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Tokopedia link */}
        <div className="text-center text-2xl mt-8">
          <p className="hidden lg:block font-semibold open-sans">
            Pemesanan dapat melalui
          </p>
          <div className="relative flex justify-center pt-2 px-36 lg:pt-2">
            <a
              href="https://www.tokopedia.com/wastewishes"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={Tokopedia}
                alt="Tokopedia"
                className="w-full lg:max-w-24 mx-auto"
              />
            </a>
          </div>
        </div>
      </div>

      {/* Modal */}
      <AnimatePresence>
        {selectedProduct && (
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedProduct(null)}
          >
            <motion.div
              className="bg-white rounded-xl p-6 max-w-md w-full mx-4 text-center shadow-lg"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.3 }}
              onClick={(e) => e.stopPropagation()}
            >
              <h2 className="text-xl font-bold mb-2">
                {selectedProduct.title}
              </h2>
              <p className="text-gray-700">{selectedProduct.desc}</p>
              <button
                onClick={() => setSelectedProduct(null)}
                className="mt-4 bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700"
              >
                Tutup
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Produk;
